import {  useState,useContext,useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_ALL_PAYROLL_INCIDENTPERIODIC, 
         GET_EXCEL_INCIDENT_COLLABORATOR,
         GET_EXCEL_INCIDENT_PERCEPTION,
         GET_EXCEL_INCIDENT_DEDUCTION,
         GET_EXCEL_INCIDENT_TYPECONCEPT,
         GET_EXCEL_INCIDENT_TYPEINCIDENTS,
         GET_EXCEL_INCIDENT_TIPOBASES,
         GET_EXCEL_INCIDENT_PERIODICO
} from '../../Querys/querys';
import {approveIncidentPeriodicProcess } from "../../context/PayrollProcess/Actions";
import ApproveIncidentPeriodic from "./Modals/ApproveIncidentPeriodic";
import EliminaIncidentPeriodic from "./Modals/EliminaIncidentPeriodic";
import { Grid } from "@material-ui/core";
import {Box} from '@mui/material';
import {createincidenciaModal,} from "../../context/PayrollProcess/Actions";
import PayrollProcessContext from "../../context/PayrollProcess/PayrollProcessContext";
import SearcherTableIncidentPayroll from "./components/SearcherTableIncidentPayroll";
import LayoutIncidentReport from "./components/LayoutIncidentReport";
import BtnIncidentPayRoll from "./components/BtnIncidentPayRoll";
import TablePayRollIncident from "./components/TablePayRollIncident";
import CrearIncidenciasDashboard from "../../components/Schedule/Modals/CrearIncidenciasDashboard";
import { CreateExcelFileIncidentLayout } from "../../components/Payroll/Modals/ExcelPayroll";
import ModalPayrollIncident from "./Modals/PayrollIncident/ModalPayrollIncident";
import { ErrorAlert } from "../../alerts/errorAlert";
import CheckPermission from "../../helpers/Administradores/Permissions";
import { v4 as uuidv4 } from 'uuid';
import "./css/IncidentPayRoll.css";

interface TabPanelProps{
    children?: React.ReactNode;
    index: any;
    value: any;
    sistemaActivo: boolean;
  }

const IncidentPayrollContent = (props:TabPanelProps) => {
    const { dispatch } = useContext(PayrollProcessContext);
    const [page, setPage] = useState(0);    
    const { dispatch: payrollDispatch }   = useContext(PayrollProcessContext);
    const [saveIncident, setSaveIncident] = useState(true)
    const [approveIncident,setApproveIncident] = useState('')
    const [selected, setSelected] = useState<readonly number[]>([]);
    const [arrayIncidEnt, setArrayIncident] = useState([])
    const [payRollIncident, setPayRollIncident] = useState([])
    const [payRollIncidentInit, setPayRollIncidentInit] = useState([])
    const [payRollIncidentFilter, setPayRollIncidentFilter] =  useState([])
    const {data: resultPayroll, startPolling, stopPolling} = useQuery(GET_ALL_PAYROLL_INCIDENTPERIODIC);
    const allPayroll = resultPayroll?.GET_ALL_PAYROLL_INCIDENTPERIODIC;
    
    useEffect(() => {
      startPolling(6000);
      return () =>{
      stopPolling()
      }
    }, [allPayroll,startPolling, stopPolling]); 

    useEffect(() => {
      if (allPayroll.length > 0 ) {
        setPayRollIncident(allPayroll) 
        setPayRollIncidentInit(allPayroll) 
        setPayRollIncidentFilter(allPayroll)   
      }
    }, [allPayroll]);

    useEffect(() => {    
      //if(payRollIncidentFilter.length>0){
        const ordreFilter=[...payRollIncidentFilter]
              ordreFilter.sort((a:any, b:any) => new Date(b.FechaGenerado).getTime() - new Date(a.FechaGenerado).getTime())
              setPayRollIncident(ordreFilter);    
              setPage(0)
      //} 
  }, [payRollIncidentFilter]);

   const Aprobar=()=>{
      const copyArrayIncident=[...arrayIncidEnt]         
      if(arrayIncidEnt.length === 0){
        return ErrorAlert({text:'Es necesario seleccionar a los colaboradores'});
      }
      const delUndefained   = copyArrayIncident.filter((dato:any) => {
        return dato !== undefined
        })
      setArrayIncident(delUndefained)  
      setApproveIncident('approve')
      approveIncidentPeriodicProcess({ _id:"" , showApproveIncidentPeriodic: true }, dispatch);        
     }
    
     const NoAprobar=()=>{
      const copyArrayIncident=[...arrayIncidEnt]  
      if(arrayIncidEnt.length === 0){
        return ErrorAlert({text:'Es necesario seleccionar a los colaboradores'});
      }
      const delUndefained   = copyArrayIncident.filter((dato:any) => {
        return dato !== undefined
        })
      setArrayIncident(delUndefained)  
      setApproveIncident('noApprove')
      approveIncidentPeriodicProcess({ _id:"" , showApproveIncidentPeriodic: true }, dispatch);     
     }
    
   const arrayBtns:any=[{
    icon:false,
    label:"No aprobar",
    functionName:NoAprobar
    },
  {
   icon:false,
   label:"Aprobar",
   functionName:Aprobar
   },]

   const resultIncidentCollaboratorExcell = useQuery(GET_EXCEL_INCIDENT_COLLABORATOR);
   const allIncidentCollaboratorExcell = resultIncidentCollaboratorExcell.data?.GET_EXCEL_INCIDENT_COLLABORATOR;

    const resultIncidentPercepcionExcell = useQuery(GET_EXCEL_INCIDENT_PERCEPTION);
    const allIncidentPercepcionExcell = resultIncidentPercepcionExcell.data?.GET_EXCEL_INCIDENT_PERCEPTION;

    const resultIncidentDeduccionExcell = useQuery(GET_EXCEL_INCIDENT_DEDUCTION);
    const allIncidentDeduccionExcell = resultIncidentDeduccionExcell.data?.GET_EXCEL_INCIDENT_DEDUCTION;

    const resultIncidentTipoConceptoExcell = useQuery(GET_EXCEL_INCIDENT_TYPECONCEPT);
    const allIncidentTipoConceptoExcell = resultIncidentTipoConceptoExcell.data?.GET_EXCEL_INCIDENT_TYPECONCEPT;

    const resultIncidentTipoIncidenciaExcell = useQuery(GET_EXCEL_INCIDENT_TYPEINCIDENTS);
    const allIncidentTipoIncidenciaExcell = resultIncidentTipoIncidenciaExcell.data?.GET_EXCEL_INCIDENT_TYPEINCIDENTS;

    const resultIncidentTipoBaseExcell = useQuery(GET_EXCEL_INCIDENT_TIPOBASES);
    const allIncidentTipoBaseExcell = resultIncidentTipoBaseExcell.data?.GET_EXCEL_INCIDENT_TIPOBASES;

    const resultIncidentPeriodicoExcell = useQuery(GET_EXCEL_INCIDENT_PERIODICO);
    const allIncidentPeriodicoExcell = resultIncidentPeriodicoExcell.data?.GET_EXCEL_INCIDENT_PERIODICO;


   const handleOnExport = () => {
    CreateExcelFileIncidentLayout(allIncidentCollaboratorExcell,allIncidentPercepcionExcell,allIncidentDeduccionExcell,allIncidentTipoConceptoExcell,allIncidentTipoIncidenciaExcell,allIncidentTipoBaseExcell,allIncidentPeriodicoExcell);
 };
    
  const createModal = () => {
    createincidenciaModal({ _id: '0', createIncidencia: true }, payrollDispatch);
  };
   

  return (
    <Grid className='containerIncident'>
      <Box className='btnsContainerIncidentPayRoll'>
         <Box className='containerFindIncidentPayRoll'>
          <SearcherTableIncidentPayroll 
              initState={payRollIncident}
              setState={setPayRollIncidentFilter}   
              stateInitial={payRollIncidentInit}                      
              label={"Buscar por nombre / sede / proyecto"}
              fields={['titulo','sede','proyecto']}
              width={400}
            /> 
         </Box>  
         <Box className="btnsIncidentPayRoll" >
         {CheckPermission("Nominas.Incidencias.Agregar") && (
          <BtnIncidentPayRoll 
           index={uuidv4()}
           icon={true}
           label={"Nueva Incidencia"}
           functionName={createModal}
           />
           )}
          {/* <LayoutIncidentReport
              handleOnExport={handleOnExport}       
          /> */}
          {arrayBtns.length>0 &&(
                arrayBtns.map((btn :any, index:any)=>(
                    <BtnIncidentPayRoll 
                        index={index}
                        icon={btn.icon}
                        label={btn.label} 
                        functionName={btn.functionName}
                     />
                ))
            )
          }     
         </Box> 
      </Box>
       <Box className="containerTablePayRollIncident" > 
          {
            payRollIncidentInit.length > 0 && (
              <TablePayRollIncident
              rows={payRollIncident}
              setArrayIncident={setArrayIncident}
              selected={selected}
              setSelected={setSelected}
              page={page}
              setPage={setPage}
             />
            )
          }
        
       </Box>
       <CrearIncidenciasDashboard saveIncident={saveIncident} setSaveIncident={setSaveIncident}/>
       {arrayIncidEnt.length>0 &&(
          <ApproveIncidentPeriodic 
              arrayIncidEnt={arrayIncidEnt}
              approveIncident={approveIncident}
              setSelected={setSelected}
           />)
        }
        <ModalPayrollIncident/>
        <EliminaIncidentPeriodic />
    </Grid>
    
  )
}

export default IncidentPayrollContent
